window.SpecialEventsAPI = new (function () {
    const self = this;
    const _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['SpecialEvents']);

    self.getSpecialEventsCategories = async () => {
        const deferred = $q.defer();

        _protected.request(`settings/categories`, 'GET', {})
            .then((response) => {

                if (response.data?.data && response.status === 200) {
                    deferred.resolve(response.data.data.categories);
                } else {
                    deferred.reject(response);
                }

            }).catch((error) => {
            deferred.reject(error);
        });

        return deferred.promise;
    };

    self.getSpecialEvents = async (brandId, payload) => {
        const deferred = $q.defer();

        _protected.request(`brands/${brandId}/events`, 'POST', payload)
            .then((response) => {

                if (!response.data || response.status !== 200) {
                    deferred.reject(response);
                }

                deferred.resolve(response.data.data.events);

            }).catch((error) => {
            deferred.reject(error);
        });

        return deferred.promise;
    }

    self.deleteSpecialEvent = async (brandId, eventId) => {
        const response = await _protected.request(`brands/${brandId}/settings/events/${eventId}`, 'DELETE', {});
        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.updateSpecialEvent = async (brandId, eventId, payload) => {
        const response = await _protected.request(`brands/${brandId}/settings/events/${eventId}`, 'PUT', payload);
        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.addNewSpecialEvent = async (brandId, payload) => {
        const response = await _protected.request(`brands/${brandId}/settings/events`, 'POST', payload);
        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.getSpecialEventPreSignedURL = async (brandId, payload) => {
        const response = await _protected.request(`brands/${brandId}/settings/events/files/presigned_url`, 'GET', payload);
        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.uploadSpecialEventsFile = async (brandId, params) => {
        const response = await _protected.request(`brands/${brandId}/settings/events/files`, 'POST', params);
        if (response?.status === 200 && response?.data?.data) {
            return response.data.data.id;
        }

        throw response;
    };

    self.getSpecialEventFileUploadStatus = async (brandId, fileId) => {
        const response = await _protected.request(`brands/${brandId}/settings/events/files/${fileId}/status`, 'GET', {});
        if (response?.status === 200 && response?.data?.data) {
            return response.data.data.status;
        }

        throw response;
    };
});
